<template>
  <div class="col-lg-10 mt-3" style="margin-top: 20px; margin-left: -20px;">
    <orderTable></orderTable>
  </div>
</template>
<script>
  import orderTable from '../../components/orderTable'
  export default {
    components: {
      orderTable: orderTable
    },
    data() {
      return {
      };
    },
    methods: {
    }
  };
</script>


// WEBPACK FOOTER //
// src/pages/Driver/DriverOrders.vue